import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const securityPoints = [
  'Managed cybersecurity services tailored to your business',
  'Threat monitoring, detection, and response',
  'Guidance for security and compliance requirements',
];

export default function CybersecurityHero() {
  return (
    <section
      id="top"
      className="min-h-[max(560px,calc(100svh-76px))] bg-cover bg-center text-white max-md:min-h-[max(580px,calc(100svh-65px))] max-md:bg-[position:58%_center]"
      style={{
        backgroundColor: '#07133b',
        backgroundImage:
          "linear-gradient(90deg, rgba(5, 15, 74, 0.66) 0%, rgba(4, 18, 54, 0.32) 58%, rgba(2, 12, 24, 0.48) 100%), url('https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/cyber%20security/cybersec.jpg')",
      }}
      aria-labelledby="cyber-hero-title"
    >
      <div className="box-border grid min-h-[inherit] w-full grid-cols-[minmax(0,1.15fr)_minmax(340px,0.85fr)] grid-rows-[1fr_auto] items-start gap-x-[7vw] gap-y-6 px-[7vw] py-[clamp(32px,5vh,64px)] max-md:grid-cols-1 max-md:grid-rows-[auto_1fr] max-md:gap-5 max-md:px-6 max-md:py-8">
        <div className="col-start-1 row-start-1 max-w-[760px] pt-[clamp(36px,7vh,72px)] max-md:pt-8">
          <h1
            id="cyber-hero-title"
            className="mb-4 max-w-[720px] text-[clamp(38px,4.3vw,56px)] font-semibold leading-[1.08] tracking-[-0.04em] max-md:max-w-[600px] max-md:text-[clamp(36px,8vw,48px)] max-[374px]:text-[34px]"
            style={{ color: '#ffffff' }}
          >
            Cybersecurity Services for Businesses
          </h1>
          <p
            className="mb-[26px] text-base font-normal leading-[27px] max-md:mb-5"
            style={{ color: '#ffffff' }}
          >
            Proactive protection to help your business stay secure and resilient.
          </p>
          <Link
            className="inline-flex min-h-12 items-center justify-center gap-3 rounded-full px-5 text-[13px] font-bold uppercase leading-tight transition-colors hover:bg-sky-500 focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-4 focus-visible:outline-white max-md:min-h-11 max-md:px-[15px] max-md:text-[11px]"
            to="/contact"
            onClick={() => window.scrollTo(0, 0)}
            style={{ backgroundColor: '#ffffff', color: '#111827' }}
          >
            Schedule a Cybersecurity Consultation
            <ArrowRight size={18} aria-hidden="true" />
          </Link>
        </div>

        <div className="col-start-2 row-start-2 w-full max-w-[570px] -translate-x-6 justify-self-end text-white max-md:col-start-1 max-md:row-start-2 max-md:max-w-[560px] max-md:translate-x-0 max-md:justify-self-stretch max-md:self-end">
          <p
            className="text-left text-base font-normal leading-[27px]"
            style={{ color: '#ffffff' }}
          >
            PT KCS helps businesses take a practical approach to cybersecurity. From identifying risks to strengthening systems and supporting compliance, we help protect your data, operations, and people.
          </p>
          <ul
            className="mt-3 pl-8 text-left text-base font-normal leading-[27px]"
            style={{ color: '#ffffff', '--tw-prose-bullets': '#ffffff' }}
          >
            {securityPoints.map((point) => <li key={point} className="mt-[3px] list-disc text-base font-normal leading-[27px] text-white marker:text-white">{point}</li>)}
          </ul>
        </div>
      </div>
    </section>
  );
}
